import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { getGroupId } from 'store/session/selectors';

import {
  fetchCustomerFacingNotes,
  types,
  updateCustomerFacingNotes,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_CUSTOMER_FACING_NOTES_REQUEST,
    watchUpdateCustomerFacingNotes,
  );
}

function* watchUpdateCustomerFacingNotes(action) {
  try {
    const groupId = yield select(getGroupId);
    const { customerFacingNotes } = action.payload;
    const { text } = yield call(
      API.supplier.updateSupplierCustomerFacingNotes,
      groupId,
      {
        text: customerFacingNotes,
      },
    );
    yield put(updateCustomerFacingNotes.success({ customerFacingNotes: text }));
  } catch (error) {
    yield put(updateCustomerFacingNotes.error(error));
  }
}

function* watchFetchCustomerFacingNotes() {
  try {
    const groupId = yield select(getGroupId);
    const { text } = yield call(API.supplier.getCustomerFacingNotes, groupId);
    yield put(fetchCustomerFacingNotes.success({ customerFacingNotes: text }));
  } catch (error) {
    console.error('FAILED TO FETCH CUSTOMER FACING NOTES', error);
    yield put(fetchCustomerFacingNotes.error({ error }));
  }
}

export function* initSaga() {
  yield all([watchFetchCustomerFacingNotes()]);
}
